import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UsersRoleModel extends BaseModel {

    constructor() {
        super({
                name: "users_role",
                tableName: 'users_role',
                label: "Vai trò người dùng",
                /* display_key: 'fullname',
                 default_order: { key: 'updated_at', direction: 'asc' }*/
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                role: {
                    name: 'role',
                    display: false
                },
                name: {
                    name: 'name',
                    display: false
                },
            },
            )
    }

}